import React from 'react';
import { Button } from '../UI/Button';
import { MessageSquare, Users, Briefcase, Award, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
interface AccessPointsProps {
  openPaymentForm?: () => void;
  openCorporateTrainingForm?: () => void;
}
export const AccessPoints = ({
  openPaymentForm,
  openCorporateTrainingForm
}: AccessPointsProps) => {
  return <section className="py-16 bg-gray-50" data-id="element-272" data-mp="rfxja7wb0uwz">
      <div className="container mx-auto px-4" data-id="element-273" data-mp="rh8nu9xkq6p5">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-274" data-mp="wf0gj661lwue">
          <h2 className="text-3xl font-bold mb-4 text-gray-800" data-id="element-275" data-mp="wfiimjfdz5a8">
            Access Points into The Networking Salon
          </h2>
          <p className="text-gray-600" data-id="element-276" data-mp="164trc4yd27xl">
            Choose your pathway into our community based on your goals and
            commitment level.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-277" data-mp="8p64urxgmebq">
          {/* The Waiting Room */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-278" data-mp="dm6a50mhjd1s">
            <div className="flex items-center mb-4" data-id="element-279" data-mp="332vsy7jxclqk">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-280" data-mp="2y1gbepgygxcx">
                <MessageSquare size={24} className="text-gray-700" data-id="element-281" data-mp="2t9ooqq0x7bs2" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-282" data-mp="2oavfj9so26xp">
                The Waiting Room
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-283" data-mp="2k88ganto1jqh">
              <span className="font-bold" data-id="element-284" data-mp="2fayr99a6va36">Free Access</span> — An open,
              welcoming space for curious minds and aspiring community members.
              Connect with others, share ideas, and build early-stage
              relationships.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-285" data-mp="8ksaew8l1j92">
              <li data-id="element-286" data-mp="8jzc8jnow22j">Submit approved announcements</li>
              <li data-id="element-287" data-mp="3lfqokd0csap">Connect with community members</li>
              <li data-id="element-288" data-mp="3jl2mx6fwk2e">Discover networking opportunities</li>
            </ul>
            <Link to="/waiting-room" className="mt-auto" data-id="element-289" data-mp="1y14ezgez7kpe">
              <Button variant="outline" className="w-full" data-id="element-290" data-mp="22scpkfs1lc45">
                Join Waiting Room
              </Button>
            </Link>
          </div>
          {/* Event Pathway */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-291" data-mp="1t2t37054f04j">
            <div className="flex items-center mb-4" data-id="element-292" data-mp="1t0gocvunt5vp">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-293" data-mp="2gtfceuqv2qg4">
                <Users size={24} className="text-gray-700" data-id="element-294" data-mp="2lqyr1vrh158l" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-295" data-mp="27qnzeqic7mmd">Event Pathway</h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-296" data-mp="2bs9iitlgsx50">
              <span className="font-bold" data-id="element-297" data-mp="wck5tlfnw0hu">Paid Access</span> — Attend a Physical
              Networking Salon and gain access to our professional community.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-298" data-mp="10fgp7ed100mu">
              <li data-id="element-299" data-mp="stbk83g59pci">Includes ongoing networking via community channels</li>
              <li data-id="element-300" data-mp="nw1ns3uc8df6">Access to Virtual Coffee Chats held every two months</li>
            </ul>
            <Link to="/events" className="mt-auto" data-id="element-301" data-mp="12siw0m78dbxi">
              <Button variant="outline" className="w-full" data-id="element-302" data-mp="12s1421rlpjve">
                Attend In-Person Event
              </Button>
            </Link>
          </div>
          {/* Inner Circle */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-303" data-mp="a4wvjmtaunev">
            <div className="flex items-center mb-4" data-id="element-304" data-mp="563ifvhxcyf8">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-305" data-mp="jty7n1wq4knk">
                <Briefcase size={24} className="text-gray-700" data-id="element-306" data-mp="f2omadi7k3hh" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-307" data-mp="3nj1i01at1p8v">
                Inner Circle Membership
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-308" data-mp="3iivlo7tlbekg">
              <span className="font-bold" data-id="element-309" data-mp="2lsjw1n84lmr1">Our yearly subscription</span> — For
              those ready to go deeper.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-310" data-mp="2pv6pfskg3fqc">
              <li data-id="element-311" data-mp="2uti025ikdu9m">Includes all Event Pathway benefits</li>
              <li data-id="element-312" data-mp="2urx3ybglq39n">Access to the AI Tools Catalogue and Resource Hub</li>
              <li data-id="element-313" data-mp="2zkzz2o111kry">Four Mastermind Sessions yearly</li>
              <li data-id="element-314" data-mp="34j1jbca6vq50">
                Discounted access to Physical Events, Services, and Products
              </li>
              <li data-id="element-315" data-mp="39hw0k9sid6n0">Group coaching + ongoing peer mentoring sessions</li>
            </ul>
            <Link to="/inner-circle" className="mt-auto" data-id="element-316" data-mp="3djpwk4rrdmgu">
              <Button className="w-full" data-id="element-317" data-mp="3dk936pbykofk">Join Inner Circle</Button>
            </Link>
          </div>
          {/* Corporate Training */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-318" data-mp="1j5q2msaz8v06">
            <div className="flex items-center mb-4" data-id="element-319" data-mp="1j82sdrmz89ns">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-320" data-mp="1o5uneuix4bw7">
                <Building2 size={24} className="text-gray-700" data-id="element-321" data-mp="1gmv56s770qef" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-322" data-mp="1bts664jncoqu">
                Corporate Training
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-323" data-mp="16te556ggqf2b">
              <span className="font-bold" data-id="element-324" data-mp="11xfd98vxeex5">For Organizations & Teams</span> —
              Transform your team with expert-led training programs.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-325" data-mp="1ul1pf5j7yrvm">
              <li data-id="element-326" data-mp="1uiyse1jnfyhe">Networking & Collaboration</li>
              <li data-id="element-327" data-mp="1pl71nauqqies">Artificial Intelligence & Digital Tools</li>
              <li data-id="element-328" data-mp="1pnt8175warvf">Leadership & Strategic Communication</li>
              <li data-id="element-329" data-mp="1ljlft008atsg">₦50,000 per participant per day</li>
              <li data-id="element-330" data-mp="e6tek87ta6zt">Minimum 5 participants</li>
            </ul>
            <Button variant="outline" className="w-full mt-auto" onClick={openCorporateTrainingForm} data-id="element-331" data-mp="e84l2fsn5sum">
              Request Training
            </Button>
          </div>
          {/* Lifetime Partner Access */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full md:col-span-2" data-id="element-332" data-mp="bkam14ixp7x8">
            <div className="flex items-center mb-4" data-id="element-333" data-mp="gjdqonv05c4o">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-334" data-mp="1n5yp1dcr6eu">
                <Award size={24} className="text-gray-700" data-id="element-335" data-mp="6lpkn1ry4i77" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-336" data-mp="3p08lrh5k5s87">
                Lifetime Partner Access
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-337" data-mp="3tu31k9i1ln20">
              <span className="font-bold" data-id="element-338" data-mp="3f459vjkwmf82">For long-term collaborators</span> —
              And past event participants.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-339" data-mp="3k2gmg22l33tz">
              <li data-id="element-340" data-mp="363p7kdfwde4s">Includes all Inner Circle benefits</li>
              <li data-id="element-341" data-mp="3a3zlqddufauq">Exclusive Digital Transformation Roadmap</li>
              <li data-id="element-342" data-mp="3a37s383t3n73">Access to the Book Library and Summaries Podcast</li>
              <li data-id="element-343" data-mp="2rgqgwkov6nr4">One-on-one engagement, ideation, and branding support</li>
            </ul>
            <Link to="/lifetime-partner" className="mt-auto" data-id="element-344" data-mp="2mhdu1zxztgoj">
              <Button className="w-full" data-id="element-345" data-mp="30gdl1e8za7nv">Get Lifetime Partner Access</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
};